// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__R3uBf","name":"styles_name__3hWlW","phone":"styles_phone__xJxqU"};